import React, { memo, useCallback, useContext, MouseEvent } from 'react'
import { HorizontalDotsMinor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'
import { TeamMemberInvite } from 'src/interfaces/team'
import { TeamMemberInvitesTableContext } from './TeamMemberInvitesTable.context'

interface Props {
  teamMemberInvite: TeamMemberInvite
}

const TeamMemberInviteActionButtonComponent = ({ teamMemberInvite }: Props) => {
  const { openTeamMemberInviteItemAction } = useContext(TeamMemberInvitesTableContext)

  const handleClickAction = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      openTeamMemberInviteItemAction(event, teamMemberInvite)
    },
    [teamMemberInvite],
  )

  return (
    <Button
      color="white"
      size="tiny"
      leftIcon={<HorizontalDotsMinor width={20} height={20} />}
      onClick={handleClickAction}
      data-testid={`my-team-invites-row-${teamMemberInvite.id}-actions-btn`}
    />
  )
}

export const TeamMemberInviteActionButton = memo(TeamMemberInviteActionButtonComponent)
